import { useContext, useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { FormContainer, useForm } from 'react-hook-form-mui';
import { AuthContext } from './AuthContext';
import ValidatedTextField from '../Utilities/Forms/ValidatedTextField';
import ForgotPasswordViewModel from './ViewModels/ForgotPasswordViewModel';
import ReturnViewModel from '../Contexts/ReturnViewModel';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';

export default function ForgotPassword() {
    const formContext = useForm<ForgotPasswordViewModel>({
        defaultValues: new ForgotPasswordViewModel(),
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<ReturnViewModel | null>(null);
    const { forgotPassword } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleForgotPassword = async (payload: ForgotPasswordViewModel) => {
        setLoading(true)
        forgotPassword(payload, (result) => {
            setLoading(false);
            setResponse(result);
        });
    };

    return (
        <FormContainer
            formContext={formContext}
            onSuccess={handleForgotPassword}
        >
            <Grid container>
                <Grid size={12}>
                    <Typography variant="h4" textAlign="center">Forgot Password</Typography>
                </Grid>
                {response !== null && response.success ?
                    <>
                        <Grid size={12}>
                            <Alert severity="success">You have been sent an email with the password reset link</Alert>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Button variant="text" size="small" onClick={() => navigate('/authorisation/login')} disabled={loading}>Return to sign in</Button>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid size={12}>
                            <Typography variant="body2">
                                Please provide the email address associated with your account. An email will be sent to this address, with a link to allow you to reset your password.
                            </Typography>
                        </Grid>
                        <Grid size={12}>
                            <ValidatedTextField label="Email" name="email" disabled={loading} />
                        </Grid>
                        {response !== null && !response.success &&
                            <Grid size={12}>
                                <Alert severity="error">{response.messages[0]}</Alert>
                            </Grid>
                        }
                        <Grid size={{ xs: 12 }}>
                            <Button type="submit" disabled={loading}>Submit</Button>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Button variant="text" size="small" onClick={() => navigate('/authorisation/login')} disabled={loading}>Remembered your password?</Button>
                        </Grid>
                    </>
                }
            </Grid>
        </FormContainer>
    );
}
